/* tslint:disable */
/* eslint-disable */
export enum DateLastVerifiedBucketEnum {
  ANCIENT = 'ANCIENT',
  OLD = 'OLD',
  NEW = 'NEW',
  RECENT = 'RECENT'
}
